import { useEffect, useState } from 'react';
import { getFirestore, collection, onSnapshot } from 'firebase/firestore';

// ============================================================================
// CHA-621 — the tenant's seeded workflow definitions, for the #/work Send lookup
// ============================================================================
// Read-only subscription to `tenants/{tenantId}/workflow_definitions` (members may read; clients may
// never write — the seed script is the only writer). Only `id` and the bound `rule` are kept: that
// pair is all the Send lookup needs, and the start_run gateway re-reads the full definition itself.
//
// InMocean-only like useRuns; the tenant path is hardcoded here, generalization deferred to CHA-25.
const TENANT_ID = 'inmocean';

export const toDefinition = (id, data) => ({
  id,
  rule: typeof data?.rule === 'string' && data.rule !== '' ? data.rule : null,
});

// useWorkflowDefinitions() — { definitions, error }. Until the first snapshot (or after an error)
// `definitions` is empty, so no finding is offered Send: the safe default is "cannot send".
export default function useWorkflowDefinitions() {
  const [definitions, setDefinitions] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    const db = getFirestore();
    const unsub = onSnapshot(
      collection(db, 'tenants', TENANT_ID, 'workflow_definitions'),
      (snap) => {
        setDefinitions(snap.docs.map((d) => toDefinition(d.id, d.data())));
        setError(null);
      },
      (err) => {
        console.error('shell: workflow definitions subscription failed', err);
        setDefinitions([]);
        setError('Workflow definitions unavailable.');
      },
    );
    return () => unsub();
  }, []);

  return { definitions, error };
}
